import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox, FormControlLabel, styled } from '@mui/material';
import { Icon } from '@elements/icon';
import { pxToRem } from '@themes';
var StyledFormControlLabel = styled(FormControlLabel)(function (_ref) {
  var theme = _ref.theme;
  return {
    '&.MuiFormControlLabel-root': {
      margin: 0,
      padding: 0,
      '& .MuiButtonBase-root': {
        margin: 0,
        padding: 0
      },
      '& .MuiTypography-root': _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
        margin: "0 0 0 ".concat(pxToRem(12))
      }),
      '& .Mui-disabled': {
        color: theme.palette.mirage
      }
    }
  };
});
var StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'fullWidth' && prop !== 'error';
  }
})(function (_ref2) {
  var theme = _ref2.theme,
    size = _ref2.size;
  var styles = {
    padding: 0,
    // unchecked behavior
    '& svg': {
      width: pxToRem(22),
      height: pxToRem(22),
      '#checkboxChecked': {
        display: 'none'
      },
      '#checkboxIndeterminate': {
        display: 'none'
      },
      '#checkboxFirstRect': {
        fill: theme.colors.white
      },
      '#checkboxLastRect': {
        stroke: theme.colors.mirage
      },
      '& g': {
        filter: 'none'
      }
    },
    '&:hover': {
      '& svg': {
        '#checkboxChecked': {
          display: 'block',
          stroke: theme.colors.mirage
        },
        '#checkboxLastRect': {
          stroke: theme.colors.mirage
        }
      }
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.mirage.main,
      '& svg': {
        '#checkboxFirstRect': {
          fill: theme.colors.white
        },
        '#checkboxLastRect': {
          stroke: theme.colors.white
        },
        '& g': {
          filter: 'url(#filter0_d_116_16339)'
        }
      }
    },
    '&.Mui-disabled': {
      '& svg': {
        '#checkboxFirstRect': {
          fill: theme.colors.mirage
        }
      }
    },
    // checked behavior
    '&.Mui-checked': {
      '& svg': {
        '#checkboxChecked': {
          display: 'block',
          stroke: theme.colors.white
        },
        '#checkboxFirstRect': {
          stroke: theme.colors.mirage,
          fill: theme.colors.mirage
        },
        '#checkboxLastRect': {
          stroke: theme.colors.mirage
        }
      },
      '&:hover': {
        '& svg': {
          '#checkboxChecked': {
            display: 'block',
            stroke: theme.colors.white
          },
          '#checkboxFirstRect': {
            stroke: theme.colors.mirage,
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          }
        }
      },
      '&.Mui-focusVisible': {
        backgroundColor: theme.palette.mirage.main,
        '& svg': {
          '#checkboxChecked': {
            display: 'block',
            stroke: theme.colors.white
          },
          '#checkboxFirstRect': {
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          },
          '& g': {
            filter: 'url(#filter0_d_116_16339)'
          }
        }
      },
      '&.Mui-disabled': {
        '& svg': {
          '#checkboxChecked': {
            display: 'block',
            stroke: theme.colors.mirage
          },
          '#checkboxFirstRect': {
            stroke: theme.colors.mirage,
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          }
        }
      }
    },
    // indeterminate behavior
    '&.MuiCheckbox-indeterminate': {
      '& svg': {
        '#checkboxIndeterminate': {
          display: 'block'
        },
        '#checkboxFirstRect': {
          stroke: theme.colors.mirage,
          fill: theme.colors.mirage
        },
        '#checkboxLastRect': {
          stroke: theme.colors.mirage
        }
      },
      '&:hover': {
        '& svg': {
          '#checkboxChecked': {
            display: 'none'
          },
          '#checkboxIndeterminate': {
            display: 'block',
            fill: theme.colors.white
          },
          '#checkboxFirstRect': {
            stroke: theme.colors.mirage,
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          }
        }
      },
      '&.Mui-focusVisible': {
        backgroundColor: theme.palette.mirage.main,
        '& svg': {
          '#checkboxIndeterminate': {
            display: 'block',
            stroke: theme.colors.white
          },
          '#checkboxFirstRect': {
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          },
          '& g': {
            filter: 'url(#filter0_d_116_16339)'
          }
        }
      },
      '&.Mui-disabled': {
        '& svg': {
          '#checkboxIndeterminate': {
            display: 'block',
            fill: theme.colors.mirage,
            stroke: 'none'
          },
          '#checkboxFirstRect': {
            stroke: theme.colors.mirage,
            fill: theme.colors.mirage
          },
          '#checkboxLastRect': {
            stroke: theme.colors.mirage
          }
        }
      }
    }
  };
  switch (size) {
    case 'medium':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          '& svg': _objectSpread(_objectSpread({}, styles['& svg']), {}, {
            width: pxToRem(22),
            height: pxToRem(22)
          })
        });
        break;
      }
    case 'small':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          '& svg': _objectSpread(_objectSpread({}, styles['& svg']), {}, {
            width: pxToRem(18),
            height: pxToRem(18)
          })
        });
        break;
      }
  }
  return styles;
});
var StyledIcon = styled(Icon)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    height: '100%',
    width: '100%',
    padding: 0
  };
});
export { StyledCheckbox, StyledFormControlLabel, StyledIcon };